// mantine
import { UnstyledButton } from '@mantine/core';
// components
// icons
import { Trash2 } from 'lucide-react';
// utils
import { IActor } from '@newo/api/gateway';
import ActorData from '@/modules/Personas/components/ActorData';

interface ActorItemProps {
    actor: IActor;
    canBeDeleted?: boolean;
    onDelete: (actor: IActor) => void;
}

const ActorItem = ({ actor, canBeDeleted, onDelete }: ActorItemProps) => {
    return (
        <div className="flex gap-4 py-1 px-2 rounded-lg hover:bg-gray-0">
            <div className="flex-1">
                <ActorData data={actor} />
            </div>
            {canBeDeleted ? (
                <UnstyledButton
                    className="text-red-6"
                    onClick={() => {
                        onDelete(actor);
                    }}
                >
                    <Trash2 />
                </UnstyledButton>
            ) : undefined}
        </div>
    );
};

export default ActorItem;
